// Theme choice (light / dark / system) per viewer: sets data-theme on <html>; tokens.css does the rest.
import { useEffect } from "react";
import { usePref } from "../lib/hooks";

export type ThemeChoice = "system" | "light" | "dark";

export function useTheme(): [ThemeChoice, (t: ThemeChoice) => void] {
  const [t, set] = usePref<ThemeChoice>("theme", "system");
  useEffect(() => {
    const el = document.documentElement;
    if (t === "system") el.removeAttribute("data-theme"); else el.setAttribute("data-theme", t);
  }, [t]);
  return [t, set];
}
